'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageViewObservable = exports.identify = exports.event = exports.pageView = undefined;

var _Rx = require('rxjs/Rx');

var _Rx2 = _interopRequireDefault(_Rx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageView = exports.pageView = function pageView(url) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: 'PageView',
    url: url,
    properties: properties
  };
};

var event = exports.event = function event(id) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: 'Event',
    id: id,
    properties: properties
  };
};

var identify = exports.identify = function identify(userId) {
  var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: 'Identify',
    userId: userId,
    traits: traits
  };
};

var pageViewObservable = exports.pageViewObservable = function pageViewObservable(history) {
  return _Rx2.default.Observable.create(function (observer) {
    // Send the current page
    observer.next(pageView(window.location.href));
    // And listen for page transitions
    var unlisten = history.listen(function (_ref) {
      var action = _ref.action;
      return observer.next(pageView(window.location.href, { action: action }));
    });
    return { unsubscribe: unlisten };
  });
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/user-actions.js